import { createAuthClient, profileAuth } from '@nestle-npus-nbm/pup-script';
import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import { useEffect, useState } from 'react';

import { PROFILE_CONFIG, PROFILE_CONFIG_LEGACY } from 'src/common/constants';
import { LDFlags } from 'src/common/launchDarkly';

// TODO-auth0: Use this
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type CognitoIdAttributes = {
  at_hash: string;
  sub: string;
  email_verified: boolean;
  iss: string;
  phone_number_verified: boolean;
  'custom:tAndC': string;
  'cognito:username': string;
  given_name: string;
  'custom:ansiraId': string;
  origin_jti: string;
  'custom:purinaAdsOptIn': string;
  'custom:ansiraUuid': string;
  aud: string;
  token_use: string;
  auth_time: number;
  name: string;
  exp: number;
  iat: number;
  family_name: string;
  jti: string;
  email: string;
};

export type User = {
  ansiraId: string;
  email: string;
  emailVerified: boolean;
  lastName: string;
  name: string;
  fullName: string;
  ansiraUuid: string;
};

export const useAuth = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const { enableAuth0 } = useFlags<LDFlags>();

  const { data, ...query } = useQuery<User | null>({
    queryKey: ['getAuth', enableAuth0],
    queryFn: async () => {
      try {
        // createAuthClient.getSession() throws when not logged in
        if (enableAuth0 && !(await createAuthClient(PROFILE_CONFIG.auth0).isAuthenticated())) {
          return null;
        }

        const session = enableAuth0
          ? await createAuthClient(PROFILE_CONFIG.auth0).getSession()
          : await profileAuth(PROFILE_CONFIG_LEGACY).getSession();

        // TODO-auth0: Add stronger type assertion
        const user = session.idTokenAttributes;

        if (!user) {
          // eslint-disable-next-line no-console
          console.error('No user found.');
          return null;
        }

        if (enableAuth0) {
          return {
            ansiraId: user.ansiraId,
            email: user.email,
            emailVerified: user.email_verified,
            lastName: user.family_name,
            name: user.given_name,
            fullName: user.name,
            ansiraUuid: user.ansiraUuid,
          };
        }

        return {
          ansiraId: user['custom:ansiraId'],
          email: user.email,
          emailVerified: user.email_verified,
          lastName: user.family_name,
          name: user.given_name,
          fullName: user.name,
          ansiraUuid: user['custom:ansiraUuid'],
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw error;
      }
    },
    enabled: isClient && typeof enableAuth0 === 'boolean',
    retry: false,
    refetchOnWindowFocus: false,
  });
  return { user: data, ...query };
};
